import React from 'react';
import logo from './Mart-POS-Lite.png';

export default function Footer() {
  const nav = id => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  const year = new Date().getFullYear();

  return (
    <footer style={{ background: '#060d1a', color: 'rgba(255,255,255,0.4)', padding: '56px 0 28px', borderTop: '1px solid rgba(255,255,255,0.05)' }}>
      <div className="container">
        <div style={{ display: 'grid', gridTemplateColumns: '2.2fr 1fr 1fr 1.2fr', gap: 40, marginBottom: 48 }}>

          {/* Brand */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
              <img
                src={logo}
                alt="Mart CMS Logo"
                style={{
                  width: 44,
                  height: 44,
                  borderRadius: 10,
                  objectFit: 'contain',
                }}
              />             <div>
                <div style={{ fontFamily: 'Plus Jakarta Sans, sans-serif', fontWeight: 800, fontSize: 16, color: 'white', letterSpacing: '-0.4px' }}>MartCMS & POS-Lite</div>
                <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.3)', letterSpacing: '1px', textTransform: 'uppercase' }}>Retail Platform by Aiprus</div>
              </div>
            </div>
            <p style={{ fontSize: 13.5, lineHeight: 1.7, maxWidth: 290, marginBottom: 20 }}>
              One connected retail ecosystem for managing products, inventory, billing, orders, deliveries, and more — built for Indian retailers.
            </p>
            {/* <div style={{ display: 'flex', gap: 8 }}>
              {['LinkedIn', 'Twitter', 'YouTube'].map(s => (
                <div key={s} style={{ padding: '6px 12px', background: 'rgba(255,255,255,0.06)', borderRadius: 6, fontSize: 11, fontWeight: 600, cursor: 'pointer', transition: 'color 0.15s', color: 'rgba(255,255,255,0.45)' }}
                  onMouseEnter={e => e.currentTarget.style.color = 'white'}
                  onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.45)'}
                >{s}</div>
              ))}
            </div> */}
          </div>

          {/* Platform */}
          <div>
            <div style={{ fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: 12, fontWeight: 700, color: 'rgba(255,255,255,0.65)', letterSpacing: '0.8px', textTransform: 'uppercase', marginBottom: 14 }}>Platform</div>
            {[['Products', 'products'], ['Features', 'features'], ['All Modules', 'modules'], ['How It Works', 'how-it-works'], ['Book a Demo', 'contact']].map(([l, id]) => (
              <button key={l} onClick={() => nav(id)} style={{ display: 'block', background: 'none', border: 'none', padding: '5px 0', fontSize: 13.5, color: 'rgba(255,255,255,0.42)', cursor: 'pointer', textAlign: 'left', transition: 'color 0.15s' }}
                onMouseEnter={e => e.currentTarget.style.color = 'white'}
                onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.42)'}
              >{l}</button>
            ))}
          </div>

          {/* Products */}
          <div>
            <div style={{ fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: 12, fontWeight: 700, color: 'rgba(255,255,255,0.65)', letterSpacing: '0.8px', textTransform: 'uppercase', marginBottom: 14 }}>Products</div>
            {['Mart CMS', 'POS-Lite', 'Customer App', 'Porter App'].map(l => (
              <div key={l} style={{ padding: '5px 0', fontSize: 13.5, color: 'rgba(255,255,255,0.42)' }}>{l}</div>
            ))}
          </div>

          {/* Contact */}
          <div>
            <div style={{ fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: 12, fontWeight: 700, color: 'rgba(255,255,255,0.65)', letterSpacing: '0.8px', textTransform: 'uppercase', marginBottom: 14 }}>Contact Us</div>
            {[['📧', 'sales@aiprus.com'], ['📞', '+91 XXXXX XXXXX'], ['🌐', 'www.aiprus.com'], ['📍', 'Lucknow, India']].map(([icon, val]) => (
              <div key={val} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '5px 0', fontSize: 13, color: 'rgba(255,255,255,0.42)' }}>
                <span style={{ fontSize: 14 }}>{icon}</span>{val}
              </div>
            ))}
            <button className="btn btn-blue btn-sm" style={{ marginTop: 16 }} onClick={() => nav('contact')}>Book a Demo</button>
          </div>
        </div>

        <div style={{ borderTop: '1px solid rgba(255,255,255,0.06)', paddingTop: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
          <div style={{ fontSize: 12.5 }}>© {year} Aiprus Software Pvt. Ltd. All rights reserved.</div>
          <div style={{ display: 'flex', gap: 24 }}>
            {['Privacy Policy', 'Terms of Service', 'Cookie Policy'].map(l => (
              <span key={l} style={{ fontSize: 12.5, cursor: 'pointer', transition: 'color 0.15s' }}
                onMouseEnter={e => e.currentTarget.style.color = 'white'}
                onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.4)'}
              >{l}</span>
            ))}
          </div>
        </div>
      </div>
      <style>{`@media(max-width:768px){.footer-grid{grid-template-columns:1fr 1fr!important}} @media(max-width:480px){.footer-grid{grid-template-columns:1fr!important}}`}</style>
    </footer>
  );
}
